import { Link } from "react-router-dom";
import { Eye, SquareX } from "lucide-react";
import { Factura } from "../../actions/facturat";

import { GotoLogin } from "../../actions/renovarLog";
import { useMutation } from "@tanstack/react-query";
import style from "../../styles/grid.module.css";
import { useState } from "react";

const Facturas = () => {
   const token = localStorage.getItem("token");
   const url = process.env.REACT_APP_URL_DIR + "factura";

   const [filters, setFilters] = useState({
      nombre: "",
   });
   const numberFormat = new Intl.NumberFormat("de-DE", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
   });
   const factura = Factura();
   // const servicios = GetServicios();
   // const pagos = GetPagos();
   // const insumos = GetInsumos();
   // const productos = GetProductos();

   const { mutate } = useMutation({
      mutationFn: (data) =>
         fetch(url , {
            method: "DELETE",
            body: JSON.stringify(data),
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         }).then((res) => res.json()),
      onSuccess: () => {
         window.location.href = "/Facturat";
      },
      onError: () => {
         alert("Error");
      },
   });

   const formatDate = (fecha) => {
      var newDate1 = fecha.substring(0, 10).split("-");
      var newdate2 = newDate1[2] + "/" + newDate1[1] + "/" + newDate1[0];
      return newdate2;
   };
   
   // Filtrado de datos basado en los filtros
   if (!factura) {
      return <div>Cargando datos...</div>;
   }
   if (factura.message === "Token inválido") {
      return <GotoLogin />;
   }

   const handleRemove = (id) => {
      const data = {
         id_primary: id,
         presupuestoId: factura.find((f) => f.id_primary === id).presupuestoId,
      };
      console.log('data: ', data);
      let text =
         "Se va a eliminar el factura selecionado!\nSelecione Aceptar or Cancelar.";

      if (window.confirm(text) === true) {
         mutate(data);
      }
   };

   const filteredData = factura.filter((item) =>
      item.nombre.toLowerCase().includes(filters.nombre.toLowerCase())
   );
   console.log("factura: ", factura);
   return (
      <>
         <div className={style.tableCli}>
            <div className={style.header}>
               <div className={style.gridTitle}>
                  <h2>Facturas Tattoo</h2>
               </div>
               <div style={{ display: "flex", gap: "10px" }}>
                  <span style={{ color: "white", paddingTop: "5%" }}>
                     Filtrar
                  </span>
                  <input
                     type="text"
                     placeholder="Filtrar por Nombre"
                     value={filters.nombre}
                     onChange={(e) =>
                        setFilters({ ...filters, nombre: e.target.value })
                     }
                     style={{ padding: "5px", borderRadius: "5px" }}
                  />
               </div>
            </div>
            <br />
            <table className={style.gridFact}>
               <thead>
                  <tr className={style.trTitle}>
                     {/* <th style={{ width: "10%" }}>Numero</th> */}
                     <th style={{ width: "10%" }}>Fecha</th>
                     <th style={{ width: "45%" }}>Cliente</th>
                     <th style={{ width: "20%" }}>Total</th>
                     <th style={{ width: "5%" }}>Acciones</th>
                  </tr>
               </thead>
               <tbody>
                  {filteredData &&
                     filteredData?.map((data) => {
                        // console.log("factura_data: ", data);
                        return (
                           <tr key={data.id} className={style.trdatos}>
                              {/* <td className={style.style_td}>{data.id}</td> */}
                              <td className={style.style_td}>
                                 {formatDate(data.fecha)}
                              </td>
                              <td className={style.style_td}>{data.nombre}</td>
                              <td className={style.precio}>
                                 $ {numberFormat.format(data.total)}
                              </td>
                              <td>
                                 <Link
                                    to={"/formFacturat"}
                                    className="dLink"
                                    state={{
                                       id: data.idpres,
                                    }}
                                 >
                                    <Eye className="lucideIcon" />
                                 </Link>
                                 &nbsp;&nbsp;
                                 <SquareX
                                    className="lucideIconDel"
                                    onClick={() => handleRemove(data.id_primary)}
                                 />
                              </td>
                           </tr>
                        );
                     })}
               </tbody>
            </table>
            {/* </div> */}
         </div>
      </>
   );
};

export default Facturas;
